export const northskyDarkTheme = {
  palette: {
    primary_500: '#9A45EC', // Primary button background, link texts
  },
  atoms: {
    bg: {
      backgroundColor: '#1F0B35',
    },
  },
}

export const northskyLightTheme = {
  palette: {
    primary_500: '#2AFBBA', // Primary button background, link texts
  },
  atoms: {
    bg: {
      backgroundColor: '#DFE1E3',
    },
  },
}

export const themes = {
  dark: northskyDarkTheme,
  dim: northskyDarkTheme,
  light: northskyLightTheme,
}
